<template>
  <div class="login-wrap">
    <acHead></acHead>
    <div class="content">
      <div class="con-wrap">
        <div class="con-lt">
          <img src="../../../static/img/pic.png" alt="">
        </div>
        <div class="con-ct"></div>
        <div class="con-rt">
          <acLogin style="margin-top:70px"></acLogin>
        </div>
      </div>
    </div>
    <acFoot></acFoot>
  </div>
</template>

<script>
  import acHead from '../account/components/Header.vue'
  import acFoot from '../component/Footer.vue'
  import acLogin from '../../components/account/Login.vue'

  export default {
    components: {
      acHead,
      acFoot,
      acLogin
    }
  }

</script>

<style lang="stylus" scoped>
.login-wrap{
    position: relative;
  min-height:800px;

}
  .content {
    background: url('../../../static/img/background.png') 100% 100% no-repeat;
    min-width: 1200px;
    width: 100%;
    min-height: 600px;
    position: relative;
    .con-wrap {
      width: 1200px;
      margin-left: calc((100% - 1200px) / 2);
      height: 100%;
      position: relative;
      display: inline-flex;
      .con-lt {
        width: 600px;
        height: 600px;
        position: relative;
        img{
          margin-top:78px;
        }
      }
      .con-ct{
        flex: 1;
        height: 600px;
      }
      .con-rt{
        width: 430px;
        height: 600px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// Login.vue?7b4f0f20